import { IItemService } from "types/admin";
import Decimal from "decimal.js";

type HeaderColumn = {
  label: string;
  key: string;
  style?: React.CSSProperties;
  styleRow?: React.CSSProperties;
  render?: (value: any, row: any) => React.ReactNode;
  groups?: {
    label: string;
    key: string;
    style?: React.CSSProperties;
    styleRow?: React.CSSProperties;
  }[];
};

type RowData = {
  homeCareSupportOfficeNameInsuranceCard?: string | null;
  businessNumberProfile?: string | null;
  serviceNameServiceDetail?: string;
  subtotalServiceDetail?: number;
  categoryLimitWithinLimitUnits?: number;
  unitPrice?: number;
  totalCostCovered?: string;
  benefitLimitInsuranceCard?: number;
  insuranceClaimAmount?: string;
  userCopaymentCovered?: string;
};
type IProps = {
  itemService: IItemService;
  totalServicesDetailRow: RowData;
  treatmentDataRows: RowData[];
};
const BillingAmountCalculations = ({
  itemService,
  totalServicesDetailRow,
  treatmentDataRows,
}: IProps) => {
  const headerColumns = [
    {
      label: "保険請求分",
      key: "insuranceClaimAmount",
      style: {
        width: "24mm",
      },
    },
    {
      label: "公費請求額",
      key: "publicExpenseClaimAmount",
      style: {
        width: "33mm",
      },
    },
    {
      label: "社会福祉法人等によ\nる利用者負担の減免",
      key: "socialWelfareDiscount",
      style: {
        width: "26mm",
      },
    },
    {
      label: "利用者請求額",
      key: "userBillingAmount",
      style: {
        width: "29mm",
      },
    },
  ] as HeaderColumn[];


  const totalCategoryLimit = treatmentDataRows.reduce((acc, row) => {
    return acc
      .plus(row.categoryLimitWithinLimitUnits || 0)
  }, new Decimal(totalServicesDetailRow.categoryLimitWithinLimitUnits || 0)).times(totalServicesDetailRow.unitPrice || 0)

  const insuranceClaimAmount = totalCategoryLimit.times(totalServicesDetailRow.benefitLimitInsuranceCard || 0).div(100).trunc().toString();
  const userBillingAmount = totalCategoryLimit.minus(totalCategoryLimit.times(totalServicesDetailRow.benefitLimitInsuranceCard || 0).div(100)).ceil().toString();  

  const data = [{ insuranceClaimAmount: insuranceClaimAmount.toString(), publicExpenseClaimAmount: 0, socialWelfareDiscount: 0, userBillingAmount: userBillingAmount.toString(),}] as any[];
  
  const renderTableHeader = (headerColumns: HeaderColumn[]) => {
    return (
      <thead>
        <tr>
          {headerColumns.map((column) => {
            return (
              <th
                key={column.key}
                rowSpan={2}
                style={{ ...column.style }}
                className="text-center whitespace-pre-line text-[10px] font-normal leading-[1.1]"
              >
                <div
                  className="min-h-[6mm] flex items-center justify-center"
                  style={{ ...column.style, ...column.styleRow }}
                >
                  {column.label}
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            {headerColumns.map((column) => {
              return (
                <td
                  key={column.key}
                  className="p-0"
                  style={{
                    fontSize: 11,
                    lineHeight: "1.2",
                    ...column.style,
                    ...column.styleRow,
                  }}
                >
                  <div
                    className="min-h-[6mm] text-right text-base mr-1 h-[6mm]"
                    style={{ ...column.style, ...column.styleRow }}
                  >
                    {column.render
                      ? column.render(row[column.key], row)
                      : row[column.key]}
                  </div>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    );
  };

  const renderNote = (notes: string[]) => {
    return (
      <div className="flex text-sm">
        <div>※</div>
        <div>
          {notes.map((note, index) => (
            <div key={index}>{note}</div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <div>
          {renderNote([
            "上記の「区分支給限度管理・利用者負担計算」欄の請求金額は、",
            "実際の請求金額と異なる場合があります。",
          ])}
          {renderNote([
            "実際の請求金額は、下記の「請求額の計算」欄に記載しています。",
          ])}
        </div>
        <div className="text-xl font-bold">請求額の計算</div>
      </div>
      <table className="mt-[0.5mm] table-fixed">
        {renderTableHeader(headerColumns)}
        {renderTableBody()}
      </table>
    </div>
  );
};
export default BillingAmountCalculations;
